module.exports = __webpack_public_path__ + "img/icon02.9a341d69.svg";